import React, { PureComponent, Fragment } from 'react';
import $ from 'jquery';
import classnames from 'classnames';

import Table from '~/core/scripts/components/Table';

class BrexitTable extends PureComponent {
  constructor() {
    super();

    this.state = {
      data: false,
      isSoftBrexit: false
    }
  }

  componentDidMount() {
    $.getJSON('data/data.json', data => this.setState({ data }));
  }

  handleHardBrexit() {
    this.setState({ isSoftBrexit: false });
  }

  handleSoftBrexit() {
    this.setState({ isSoftBrexit: true });
  }

  render() {
    const { isSoftBrexit } = this.state;

    const HardBrexitButtonClasses = classnames('btn', { active: !isSoftBrexit });
    const SoftBrexitButtonClasses = classnames('btn', { active: isSoftBrexit });

    const valueKey = isSoftBrexit ? 'soft' : 'hard';
    const cvalueKey = isSoftBrexit ? 'change_soft' : 'change_hard';

    return (
      <Fragment>
        <div className="brexit-map-controls">
          <div className="btn-group horizontal">
            <button onClick={() => this.handleHardBrexit()} className={HardBrexitButtonClasses}>Harter Brexit</button>
            <button onClick={() => this.handleSoftBrexit()} className={SoftBrexitButtonClasses}>Weicher Brexit</button>
          </div>
        </div>

        <Table data={this.state.data} valueKey={valueKey} cvalueKey={cvalueKey} />
      </Fragment>
    );
  }
}

export default BrexitTable;
